import type { ThemeWithoutTokens } from '../theme.types';

export const tooltipTokens = (theme: ThemeWithoutTokens) =>
  ({
    tooltipOffsetX: theme.space.component.x.s,
    tooltipOffsetY: theme.space.component.y.s,
    tooltipPaddingX: theme.space.component.x.s,
    tooltipPaddingY: theme.space.component.y.s,
    tooltipBackgroundColor: theme.colors.body.text,
    tooltipTextColor: theme.colors.body.background,
    tooltipRadius: theme.radiuses.m,
    tooltipZIndex: theme.zIndices.tooltip,
    tooltipMaxWidth: '320px',
  }) as const;
